import React, { useRef, useEffect } from 'react';
import './SpeedBoxGauge.css';
import { formatDataRateSmart } from 'kontrolEdge/helpers/formatDataRate';

interface SpeedboxGaugeProps {
  /** 0–100 percent to fill the gauge */
  percent: number;
  /** ping in ms */
  ping?: number;
  /** upload in Mb/s */
  up?: number;
  /** download in Mb/s */
  down: number;
}

export const SpeedboxGauge: React.FC<SpeedboxGaugeProps> = ({
  percent,
  down,
}) => {
  const needleRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!needleRef.current) return;
    // map 0–100% → −45°…+135°  (span of 180°)
    const angle = (percent / 100) * 180 - 45;
    needleRef.current.style.transform = `rotate(${angle}deg)`;
  }, [percent]);

  return (
    <div className="speedbox">
      <div className="speedbox__groove" />
      <div ref={needleRef} className="speedbox__score" />
      <div className="speedbox__odo">
        <div className="speedbox__ping">
          {/* <i className="fa fa-clock-o" /> {ping}<span>ms</span> */}
        </div>
        <div className="speedbox__up">
          {/* <i className="fa fa-arrow-circle-up" /> {up}<span>mb/s</span> */}
        </div>
        <div className="speedbox__down">
          <i className="fa fa-arrow-circle-down" /> {formatDataRateSmart(down)}
        </div>
      </div>
      <div className="speedbox__base" />
    </div>
  );
};
